import {Middleware} from '@reduxjs/toolkit';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {Platform} from 'react-native';

/**
 * Middleware to clear report-related session storage when auth state is reset
 */
export const clearReportSessionStorageMiddleware: Middleware =
  () => next => (action: any) => {
    // Check if this is the resetState or clearCache action
    if (action.type === 'auth/resetState' || action.type === 'auth/clearCache') {
      const clearStorage = async () => {
        try {
          if (Platform.OS === 'web') {
            const keysToRemove: string[] = [];
            for (let i = 0; i < sessionStorage.length; i++) {
              const key = sessionStorage.key(i);
              if (key && key.startsWith('report_')) {
                keysToRemove.push(key);
              }
            }
            keysToRemove.forEach(key => sessionStorage.removeItem(key));

            // Also clear multiTab for web
            localStorage.removeItem('multiTab.tabs');
            localStorage.removeItem('multiTab.current');
          } else {
            const allKeys = await AsyncStorage.getAllKeys();
            const reportKeys = allKeys.filter(key => key.startsWith('report_'));

            // Note: 'pos_offline_order_queue' is intentionally NOT cleared here.
            // It holds POS orders taken while offline and not yet synced to the
            // server - wiping it on logout/session-expiry/inactivity-timeout
            // would silently discard real, unsynced orders. That queue is only
            // ever cleared by offlineOrderQueue.ts itself (per-item, on
            // successful sync).
            const keysToRemove = [...reportKeys, 'multiTab.tabs', 'multiTab.current'];

            await AsyncStorage.multiRemove(keysToRemove);
          }
        } catch (error) {
          console.error('Error clearing cache storage:', error);
        }
      };
      clearStorage();
    }
    return next(action);
  };

